var _sodipodiNamedview, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFast(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 46,
    height: 33,
    viewBox: "0 0 46 33",
    fill: "none",
    id: "svg3",
    sodipodiDocname: "fast.svg",
    inkscapeVersion: "1.4 (86a8ad7, 2024-10-11)",
    xmlnsInkscape: "http://www.inkscape.org/namespaces/inkscape",
    xmlnsSodipodi: "http://sodipodi.sourceforge.net/DTD/sodipodi-0.dtd",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsSvg: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _sodipodiNamedview || (_sodipodiNamedview = /*#__PURE__*/React.createElement("sodipodiNamedview", {
    id: "namedview3",
    pagecolor: "#505050",
    bordercolor: "#eeeeee",
    borderopacity: 1,
    inkscapeShowpageshadow: 0,
    inkscapePageopacity: 0,
    inkscapePagecheckerboard: 0,
    inkscapeDeskcolor: "#d1d1d1",
    inkscapeZoom: 11.313709,
    inkscapeCx: 27.400388,
    inkscapeCy: 14.009553,
    "inkscapeWindow-width": 1440,
    "inkscapeWindow-height": 847,
    "inkscapeWindow-x": -8,
    "inkscapeWindow-y": -8,
    "inkscapeWindow-maximized": 1,
    "inkscapeCurrent-layer": "svg3"
  })), /*#__PURE__*/React.createElement("path", {
    d: "m 29.5514,32.8636 c -4.5682,0 -8.4375,-1.5852 -11.608,-4.7557 C 14.773,24.9375 13.1878,21.0682 13.1878,16.5 c 0,-4.5341 1.5852,-8.3949 4.7556,-11.5824 3.1705,-3.1875 7.0398,-4.781247 11.608,-4.781247 4.5341,0 8.3949,1.593747 11.5824,4.781247 3.1875,3.1875 4.7812,7.0483 4.7812,11.5824 0,4.5682 -1.5937,8.4375 -4.7812,11.6079 -3.1875,3.1705 -7.0483,4.7557 -11.5824,4.7557 z m 0,-4.0909 c 3.4091,0 6.3068,-1.1932 8.6932,-3.5795 2.3863,-2.3864 3.5795,-5.2841 3.5795,-8.6932 0,-3.4091 -1.1932,-6.3068 -3.5795,-8.69319 -2.3864,-2.38637 -5.2841,-3.57955 -8.6932,-3.57955 -3.4091,0 -6.3068,1.19318 -8.6932,3.57955 -2.3863,2.38639 -3.5795,5.28409 -3.5795,8.69319 0,3.4091 1.1932,6.3068 3.5795,8.6932 2.3864,2.3863 5.2841,3.5795 8.6932,3.5795 z m 4.6534,-4.6534 2.9148,-2.9148 -5.5227,-5.5227 V 8.31817 h -4.091 V 17.3693 Z M 2.96049,10.3636 V 6.27272 H 11.1423 V 10.3636 Z M 0.915039,18.5454 V 14.4545 H 11.1423 v 4.0909 z m 2.045451,8.1819 v -4.0909 h 8.18181 v 4.0909 z",
    fill: "url(#paint0_linear_842_5840)",
    id: "path2",
    style: {}
  }), _defs || (_defs = /*#__PURE__*/React.createElement("defs", {
    id: "defs3"
  }, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_842_5840",
    x1: 0.0985876,
    y1: 17.1865,
    x2: 46.6485,
    y2: 17.1865,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6430E6",
    id: "stop2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#895EF6",
    id: "stop3"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFast);
export default __webpack_public_path__ + "static/media/fast.fdfe1c34fd1f424cb3b34e17d5b1a90c.svg";
export { ForwardRef as ReactComponent };